<template>
  <div class="col-12 page_content_area">
    <div class="container">
      <div class="page_title">授權紀錄</div>
      
      <div class="authorized_record_block">
        <div v-if="!hideAuthorizeButton && currentCareerExpoBoothsStatusGetter <= 3" class="authorized_input d-flex align-items-center">
          <input placeholder="請輸入驗證碼" v-model="authorizationCode"/>
          <button class="btn--pill pill blue" @click="authorization()">我要驗證</button>
          <div v-if="errMsg" class="hint">* {{errMsg}}</div>
        </div>
        <div class="table_holder">
          <table>
            <thead>
              <tr>
                <th>活動名稱</th>
                <th>授權公司</th>
                <th>被授權公司</th>
                <th>時間</th>
                <th>攤位數量</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="record of currentAuthorizationRecordGetter" :key="record.time">
                <th>{{ record.enlistActivityName }}</th>
                <th>{{ record.giveEnterprise }}</th>
                <th>{{ record.takeEnterprise }}</th>
                <th>{{ record.time }}</th>
                <th>{{ record.give_amount }}</th>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'EnterpriseAuthorizedRecordContent',
  components: {
  },
  data () {
    return {
      earliestBoothTimeCountdown: '',
      earliestBoothTimeCountdownInterval: null,
      hideAuthorizeButton:false,
      authorizationCode: '',
      errMsg:''
    }
  },
  computed: {
    ...mapGetters('pages/enterprises', [
      'currentAuthorizationRecordGetter',
      'currentCareerExpoBoothsStatusGetter',
    ]),
    ...mapGetters('pages/campus-recruiting', [
      'currentExpoInfoGetter',
    ]),
  },
  async created () {
    this.setEnlistBoothTimeCountdown();
    
    this.earliestBoothTimeCountdownInterval = setInterval(() => {
      this.setEnlistBoothTimeCountdown()
    }, 1000);
    
    let id = this.$route.params.id;
    this.getEnterpriseBoothAuthorizationRecordById(id);
    this.getCareerExpoBoothsStatus(id);
  },
  methods: {
    ...mapActions('pages/enterprises', [
      'getEnterpriseBoothAuthorizationRecordById',
      'getEnterpriseBoothAuthorizationTakeById',
      'getCareerExpoBoothsStatus',
    ]),
    async authorization() {
      try {
        this.errMsg = '';
        await this.getEnterpriseBoothAuthorizationTakeById({
          id: this.$route.params.id,
          code: this.authorizationCode,
        });
        await this.$router.go(0);
      } catch (error) {
        if (error.response && error.response.data)
          this.errMsg = error.response.data.message || "未知錯誤";
      }
    },
    setEnlistBoothTimeCountdown () {
      let earliestBoothTime = this.currentExpoInfoGetter.earliest_booth_time;
      if (!earliestBoothTime) return;
      
      let diff = this.$moment(earliestBoothTime).diff(this.$moment());
      let duration = this.$moment.duration(diff);
      this.earliestBoothTimeCountdown = [
        fill_left(duration.days()) + '天',
        fill_left(duration.hours()) + '小時',
        fill_left(duration.minutes()) + '分',
        fill_left(duration.seconds()) + '秒',
      ].join(' : ');

      // 距離最近的選位時間10分鐘 即不能再輸入授權碼
      if (diff < 10*60*1000) {
        clearInterval(this.earliestBoothTimeCountdownInterval);
        this.hideAuthorizeButton = true;
      }
      
      function fill_left(val) {
        return (val < 10 ? '0' : '') + val;
      }
    },
  }
}
</script>